import { JWebCoreFacade } from './JWebCoreFacade';
import { loggerDecorator } from '../../../interface/v1/clientOsLogger/decorators';
import { withTimeout } from '../../../utils/withTimeout';

/**
 * Facade for ContainerPlugin operations (Only Native)
 */
export class ContainerPluginFacade {
  private static jWebContainerInstanceId = (async () => {
    return await ContainerPluginFacade.getInstanceId();
  })();

  /**
   * Get the container instance ID
   */
  @loggerDecorator.debug.d3()
  public static async getInstanceId(): Promise<string> {
    try {
      const JWeb = await JWebCoreFacade.getJWeb();

      if (!JWeb.isNative) {
        return undefined;
      } else if (!JWeb?.Plugins?.Container?.getInfo) {
        console.error(
          'JWeb error: JWeb.Plugins.Container.getInfo() is not available'
        );
        return undefined;
      }

      const containerInfo = await withTimeout(
        JWeb?.Plugins?.Container?.getInfo(),
        {
          ms: 2000,
          message: 'JWeb.Plugins.Container.getInfo() timed out'
        }
      );

      return containerInfo?.instanceId;
    } catch (e) {
      console.error(
        'JWeb error: Failed to get JWeb.Plugins.Container.getInfo. ',
        e
      );
      return undefined;
    }
  }

  /**
   * Get the JWeb container instance ID
   */
  @loggerDecorator.debug.d3()
  public static async getJWebContainerInstanceId(): Promise<
    string | undefined
  > {
    return this.jWebContainerInstanceId;
  }
}
